export enum InventoryRouteNames {
  INVENTORY_ROOT = 'Inventory',
}
